import Vue from 'vue'
import Vuex from 'vuex'
import games from './games'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default (requireSaleId, apiPrefix, host, msisdnRegex, msisdnPrefix) => new Vuex.Store({
  modules: {
    global: { 
      state: { msisdnRegex, msisdnPrefix },
      getters: { requireSaleId: () => requireSaleId, apiPrefix: () => apiPrefix, host: () => host,
        formatMsisdn: (state) => (msisdn) => {
          const arr = msisdn.split(' ').join('').match(state.msisdnRegex)
          if (arr !== null) {
            return `${ msisdnPrefix }${ arr[2] }`
          } else {
            return undefined
          }
        }
      }
    },
    games
  },
  strict: debug
})


// WEBPACK FOOTER //
// ./src/store/gg/index.js